export default __webpack_public_path__ + "static/agri_map-3f58e77bdd2af61d7ee55322b002832c.png";